module.exports = __webpack_public_path__ + "static/media/icon-60@3x.5ad7dff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-60@3x.png
// module id = 370
// module chunks = 0